import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import YardOutlined from '@mui/icons-material/YardOutlined';
import CardGiftcardOutlined from '@mui/icons-material/CardGiftcardOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import {
  useCanSeeContentManagement,
  useCanSeeProductEditor,
  useCanSeeUserAccess
} from 'hooks/useUserState_utils';
import { AdminDashboard } from '../../../../components/common/AdminDashBoard/AdminDashBoard';
import { useFlags } from 'launchdarkly-react-client-sdk';
import DesignServicesOutlined from '@mui/icons-material/DesignServicesOutlined';

export const ManagementDashboard = () => {
  const canSeeProductEditor = useCanSeeProductEditor();
  const canSeeUserAccess = useCanSeeUserAccess();
  const canSeeContentManagement = useCanSeeContentManagement();
  const { supplierPortalContactManagement } = useFlags();

  const section = [
    {
      title: 'Ingredients',
      logo: <YardOutlined fontSize="large" />,
      description: 'Create and manage ingredients and their attributes.',
      link: '/admin/products/ingredients',
      hasAccess: canSeeProductEditor
    },
    {
      title: 'Concepts',
      logo: <CardGiftcardOutlined fontSize="large" />,
      description: 'Create and manage concepts and their attributes.',
      link: '/admin/products/formulations',
      hasAccess: canSeeProductEditor
    },
    {
      title: 'User access',
      logo: <PeopleAltOutlined fontSize="large" />,
      description: 'Control access for internal and external users.',
      link: '/admin/user',
      hasAccess: canSeeUserAccess
    },
    {
      title: 'Signup Contacts',
      logo: <ContactPageOutlinedIcon fontSize="large" />,
      description: 'Control who will receive emails about new users.',
      link: '/admin/contacts',
      hasAccess: supplierPortalContactManagement && canSeeUserAccess
    },
    {
      title: 'Content',
      logo: <DesignServicesOutlined fontSize="large" />,
      description: 'Manage your pages content here.',
      link: '/admin/content',
      hasAccess: canSeeContentManagement
    }
  ];

  return <AdminDashboard sections={section} />;
};
